import React from "react";
import {Div, ModalPage, ModalPageHeader, ModalRoot, PanelHeaderButton} from "@vkontakte/vkui";
import {Icon24Cancel} from "@vkontakte/icons";
import {MODAL_STANDS_SHARE} from "../assets/constants";
import StandsShareList from "./StandsShareList";

/*
 * Модалка отчёта «Доля видов стендов» (ТЗ 237).
 * Должна монтироваться в modal= верхнего SplitLayout (FragmentMap),
 * иначе обрезается сайдбаром карты.
 */
const StandsShareModal = ({activeModal, title, groupTypeStats, onClose}) => {
    return (
        <ModalRoot activeModal={activeModal}>
            <ModalPage id={MODAL_STANDS_SHARE}
                       onClose={onClose}
                       settlingHeight={100}
                       header={
                           <ModalPageHeader
                               after={
                                   <PanelHeaderButton onClick={onClose}>
                                       <Icon24Cancel/>
                                   </PanelHeaderButton>
                               }
                           >
                               {title || 'Доля видов стендов'}
                           </ModalPageHeader>
                       }
            >
                <Div>
                    <StandsShareList groupTypeStats={groupTypeStats}
                                     emptyText="Нет данных о стендах"/>
                </Div>
            </ModalPage>
        </ModalRoot>
    )
}

export default StandsShareModal
